export const createInviteRole = 'Merchant/CreateInviteRole';
export const listInviteRole = 'Merchant/ListInviteRole';
export const updateRole = 'Merchant/UpdateRole';
